import React from "react";
import GenericDrawer from "./GenericDrawer";
import { useSelector } from "react-redux";
import { AccountSelectors } from "../../redux/selectors";
import { DrawerType, VerticalTransition } from "../../constants";
import MobileRewards from "../MyAccountArea/components/MobileRewards/MobileRewards";
import MyAccountAreaHeader from "../MyAccountArea/components/MyAccountAreaHeader/MyAccountAreaHeader";
import { TrackingInfo } from "../tracking/TrackingInfoMyAccountArea";
import { useNoScroll } from "../../hooks";

const MobileRewardsDrawer = () => {
  const mobileRewardsDrawerVisible = useSelector(
    AccountSelectors.rewardDrawerActive
  );

  useNoScroll("mobileRewardsDrawer", mobileRewardsDrawerVisible);

  return (
    <GenericDrawer
      isVisible={mobileRewardsDrawerVisible}
      menu={DrawerType.MobileRewardsDrawer}
      header={
        <MyAccountAreaHeader drawerType={DrawerType.MobileRewardsDrawer} />
      }
      verticalTransition={VerticalTransition.Right}
    >
      <MobileRewards trackingInfo={TrackingInfo} />
    </GenericDrawer>
  );
};

export default React.memo(MobileRewardsDrawer);
